// extracted by mini-css-extract-plugin
export default {"containerMap":"Map_containerMap__CYxCe","mapProjects":"Map_mapProjects__24glJ","tagsOverlay":"Map_tagsOverlay__3Rf5R"};